import DateNaissanceInput from "components/DateNaissanceInput";
import PageHeader from "components/PageHeader";
import { Template } from "layouts/Template";
import React from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setCurrentEleve } from "redux_dir/features/eleveSlice";
import { toast } from "sonner";
import { useGetClassesAllQuery } from "redux_dir/features/classeApi";
import { useAddElevesMutation, useGetElevesByParentQuery } from "redux_dir/features/eleveApi";
// import { getEleves } from "redux/features/eleveSlice";
import { getParentForm } from "redux_dir/features/parentSlice";
import { Loader, Plus, X } from "tabler-icons-react";
import { v4 as uuidv4 } from "uuid";

function organiserClasses(classes) {
  const ordreClasses = ["CI", "CP", "CE1", "CE2", "CM1", "CM2", "Collège", "Lycée"];

  // Sort while ensuring unknown class names go to the end
  return classes.sort((a, b) => {
    const indexA = ordreClasses.indexOf(a.name);
    const indexB = ordreClasses.indexOf(b.name);

    // Classes not in the list will have index = -1
    if (indexA === -1 && indexB === -1) return 0; // both unknown
    if (indexA === -1) return 1; // a should go after known ones
    if (indexB === -1) return -1; // b should go after known ones
    return indexA - indexB; // normal order for known ones
  });
}


const formatFullName = (name) => {
  const nameStringToArray = name.trim().split(" ");

  const lastName = nameStringToArray.pop();
  const firstName = nameStringToArray.join(" ");
  return { firstName, lastName };
};

const champClass =
  "w-full bg-white text-[#000] text-base border-2 border-gray rounded-xl px-3 py-3 " +
  "focus:outline-none focus:border-secondary focus:ring-2 focus:ring-secondary/20 transition-colors";

function ChevronBas() {
  return (
    <svg
      className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[rgba(0,0,0,0.45)]"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
}

function FormEnfant() {
  const navigation = useNavigate();
  const location = useLocation();

  const { data: classes, isLoading, refetch } = useGetClassesAllQuery({});

  const dispatch = useDispatch();

  const [ADDELEVE, { isLoading: isAddLoading }] = useAddElevesMutation();

  // const students = useSelector(getEleves);

  const parent = useSelector(getParentForm);

  // Récupérer la liste des enfants existants
  const { data: existingEleves } = useGetElevesByParentQuery(
    { parentId: parent?.id },
    {
      skip: !parent?.id,
    }
  );

  // Recharger les classes au montage du composant pour les nouveaux utilisateurs
  React.useEffect(() => {
    console.log('[FormEnfant] Montage du composant');
    console.log('[FormEnfant] Classes actuelles:', classes);
    console.log('[FormEnfant] isLoading:', isLoading);

    // Attendre un peu puis recharger pour les nouveaux utilisateurs
    const timer = setTimeout(() => {
      console.log('[FormEnfant] Rechargement des classes...');
      refetch().then((result) => {
        console.log('[FormEnfant] Résultat du refetch:', result);
      });
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // console.log({ parent });

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    control,
  } = useForm({
    defaultValues: {
      enfants: [{ id: uuidv4(), fullName: "", classeId: "", date_naissance: "" }],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: "enfants", // unique name for your Field Array
  });
  // console.log({ classes });
  let error = false;
  let hasError = false;

  const onSubmit = async (data) => {
    data.enfants?.forEach((enfant, index) => {
      if (enfant?.fullName.trim().split(" ").length <= 1) {
        setError(`enfants.${index}.fullName`, {
          type: "manual",
          message: "Veuillez spécifier le prénom et nom",
        });
        hasError = true;
      }
    });

    if (hasError) return;

    const dataEleves = data.enfants.map((enfant) => ({
      ...enfant,
      classe: classes?.data?.find((classe) => classe?.id?.toString() === enfant?.classeId)?.name,
    }));

    const formatdataEleve = dataEleves.map((item) => {
      if (
        !formatFullName(item?.fullName).firstName &&
        !formatFullName(item?.fullName).lastName
      ) {
        return setError("root", {
          message: "Il nous le prenom et nom de l'enfant",
        });
      }
      return {
        parrentId: parseInt(parent?.id),
        classeId: parseInt(item?.classeId),
        ...formatFullName(item?.fullName),
        date_naissance: item?.date_naissance || null,
        type: "TESTEUR",
      };
    });

    // Vérifier les doublons avec les enfants existants
    const existingChildren = existingEleves?.data || [];
    const duplicates = [];

    formatdataEleve.forEach((newChild, index) => {
      const normalizedNewName = `${newChild.firstName?.toLowerCase().trim()} ${newChild.lastName?.toLowerCase().trim()}`;

      // Vérifier contre les enfants existants
      const existingDuplicate = existingChildren.find((existing) => {
        const normalizedExistingName = `${existing.firstName?.toLowerCase().trim()} ${existing.lastName?.toLowerCase().trim()}`;
        return normalizedExistingName === normalizedNewName;
      });

      if (existingDuplicate) {
        duplicates.push(`${newChild.firstName} ${newChild.lastName}`);
        setError(`enfants.${index}.fullName`, {
          type: "manual",
          message: "Cet enfant existe déjà dans votre liste",
        });
      }

      // Vérifier les doublons dans le formulaire actuel
      const formDuplicate = formatdataEleve.find((other, otherIndex) => {
        if (index === otherIndex) return false;
        const normalizedOtherName = `${other.firstName?.toLowerCase().trim()} ${other.lastName?.toLowerCase().trim()}`;
        return normalizedOtherName === normalizedNewName;
      });

      if (formDuplicate && !duplicates.includes(`${newChild.firstName} ${newChild.lastName}`)) {
        duplicates.push(`${newChild.firstName} ${newChild.lastName}`);
        setError(`enfants.${index}.fullName`, {
          type: "manual",
          message: "Ce nom est déjà utilisé dans le formulaire",
        });
      }
    });

    if (duplicates.length > 0) {
      toast.error(`Enfant(s) en double détecté(s): ${duplicates.join(", ")}`);
      return;
    }

    // return console.log({ formatdataEleve });

    try {
      let promises = [];
      for (let i = 0; i < formatdataEleve.length; i++) {
        promises.push(ADDELEVE({ body: { ...formatdataEleve[i] } }));
      }

      const res = await Promise.all([...promises]);
      let error = 0;
      res?.forEach((item, index) => {
        if (item.error) {
          error = index + 1;
          // return toast.error("Error l'or de l'ajout de lenfant : ", index + 1);
        }
      });
      if (error) {
        return toast.error("Error l'or de l'ajout de lenfant : ", error);
      }
      toast.success("Création des enfants réussie");

      // On ouvre directement le suivi de l'enfant qui vient d'être créé :
      // une étape de moins avant le premier diagnostic.
      const created = res?.[0]?.data?.data ?? res?.[0]?.data;
      if (created?.id) {
        dispatch(
          setCurrentEleve({
            id: created?.id,
            classe: created?.classe?.name ?? created?.classe,
            classeId: created?.classe?.id ?? created?.classeId,
            fullName: [created?.firstName, created?.lastName]
              .filter(Boolean)
              .join(" "),
          })
        );
        navigation(`/${created?.id}/matiere`, { replace: true });
      } else if (location?.state?.exist) {
        navigation(-1);
      } else {
        navigation("../select-enfant", { replace: true });
      }
    } catch (error) {
      // console.log({ error });
      toast.error("Une erreur c'est produite");
    }
  };

  const peutAjouterUnEnfant = location?.state?.nombre === "n";

  return (
    <Template
      header={<PageHeader title={"Formulaire des enfants"} />}
      style={{
        backgroundColor: "#F5F7FA",
        padding: 10,
      }}
    >
      <div className="flex-1 overflow-auto pb-2">
        <div className="mb-4">
          <h1 className="text-primary font-bold text-xl">
            Renseigner les informations des enfants
          </h1>
          <p className="text-sm text-[rgba(0,0,0,0.55)] mt-1">
            Ces informations nous permettent d'adapter les exercices au niveau
            de chaque enfant.
          </p>
        </div>

        <form action="" className="">
          {fields.map((field, index) => (
            <div
              className="mb-4 bg-white rounded-2xl border border-black/5 shadow-sm p-4"
              key={field.id}
            >
              <div className="flex items-center justify-between mb-3">
                <span className="inline-flex items-center bg-secondary/10 text-primary font-bold text-sm rounded-full px-3 py-1.5">
                  Enfant {index + 1}
                </span>
                {peutAjouterUnEnfant && fields.length > 1 ? (
                  <button
                    type="button"
                    aria-label={`Retirer l'enfant ${index + 1}`}
                    className="p-2 rounded-full text-danger hover:bg-danger/10 transition-colors"
                    onClick={() => remove(index)}
                  >
                    <X size={18} />
                  </button>
                ) : null}
              </div>

              <div className="mb-4">
                <label
                  htmlFor={`fullname-${index}`}
                  className="block text-sm text-[rgba(0,0,0,0.6)] font-bold mb-2"
                >
                  Prénom et nom
                </label>
                <input
                  id={`fullname-${index}`}
                  placeholder="Ex : Awa Ndiaye"
                  className={champClass}
                  type="text"
                  autoComplete="off"
                  {...register(`enfants.${index}.fullName`, {
                    required: "Saisir le nom complet est obligatoire",
                  })}
                />
                {errors.enfants?.[index]?.fullName && (
                  <p className="text-danger text-sm mt-2">
                    {errors.enfants[index].fullName.message}
                  </p>
                )}
              </div>

              <div className="mb-4">
                <Controller
                  control={control}
                  name={`enfants.${index}.date_naissance`}
                  render={({ field: { value, onChange } }) => (
                    <DateNaissanceInput
                      id={`date-naissance-${index}`}
                      value={value || ""}
                      onChange={onChange}
                    />
                  )}
                />
              </div>

              <div>
                <label
                  htmlFor={`classe-${index}`}
                  className="block text-sm text-[rgba(0,0,0,0.6)] font-bold mb-2"
                >
                  Classe
                </label>
                {isLoading ? (
                  <div className="flex items-center gap-2 p-3 text-[rgba(0,0,0,0.6)]">
                    <Loader size={16} className="animate-spin" />
                    <span>Chargement des classes...</span>
                  </div>
                ) : !classes || !classes?.data || classes?.data?.length === 0 ? (
                  <div className="p-3 text-danger text-sm">
                    Aucune classe disponible. Veuillez réessayer.
                    <button
                      type="button"
                      onClick={() => refetch()}
                      className="ml-2 text-primary underline"
                    >
                      Recharger
                    </button>
                  </div>
                ) : (
                  <div className="relative">
                    <select
                      id={`classe-${index}`}
                      className={`${champClass} appearance-none pr-10`}
                      {...register(`enfants.${index}.classeId`, {
                        required: "La classe est obligatoire",
                      })}
                      defaultValue={field?.classeId?.toString()}
                    >
                      <option value={""}>Sélectionner une classe</option>
                      {organiserClasses(
                        classes?.data
                          ?.filter(
                            (classe) =>
                              classe?.name?.toLowerCase()?.trim() !==
                              "hv3eme"
                          )
                          ?.filter(
                            (classe) =>
                              classe?.name?.toLowerCase()?.trim() !== "ocs4"
                          )
                      ).map((classe) => (
                        <option
                          value={classe?.id?.toString()}
                          key={classe?.id}
                        >
                          {classe?.name}
                        </option>
                      ))}
                    </select>
                    <ChevronBas />
                  </div>
                )}
                {errors.enfants?.[index]?.classeId && (
                  <p className="text-danger text-sm mt-2">
                    {errors.enfants[index].classeId.message}
                  </p>
                )}
              </div>
            </div>
          ))}

          {peutAjouterUnEnfant ? (
            <button
              type="button"
              className="w-full flex items-center justify-center gap-2 border-2 border-dashed border-primary/40 text-primary font-medium rounded-2xl py-3 hover:bg-primary/5 transition-colors"
              onClick={() =>
                append({
                  classeId: "",
                  fullName: "",
                  date_naissance: "",
                  id: uuidv4(),
                })
              }
            >
              <Plus size={18} />
              Ajouter un enfant
            </button>
          ) : null}

          <div className="mt-6 pb-24">
            <button
              type="button"
              className="w-full flex items-center justify-center gap-2 bg-primary text-white font-semibold rounded-full py-3.5 shadow-lg disabled:opacity-60 active:scale-[0.99] transition-transform"
              onClick={handleSubmit(onSubmit)}
              disabled={isSubmitting || fields.length <= 0 || isAddLoading}
            >
              {isAddLoading ? <Loader size={18} className="animate-spin" /> : null}
              Enregistrer
            </button>
          </div>
        </form>
      </div>
    </Template>
  );
}

export default FormEnfant;
